/**
 * Constants for Store Category Builder – Listing Assignment
 */

// Request timeout (ms) – stay under 30s load balancer limit (aligned with server assignListings)
export const ASSIGN_LISTINGS_REQUEST_TIMEOUT_MS = 30000;

// Max listing updates per API request (assign + unassign combined)
export const ASSIGN_LISTINGS_MAX_BATCH_SIZE = 26;

// Listings per page in Instant Search / infinite scroll
export const LISTINGS_PAGE_SIZE = 20;

// Max listings fetched once for Assign listings search (client-side filter/sort)
export const LISTINGS_INITIAL_FETCH_SIZE = 500;

// Search input debounce (ms)
export const LISTING_SEARCH_DEBOUNCE_MS = 300;

// Delay before requesting store category sync after save (ms) – allows listing assignment updates to propagate
export const STORE_CATEGORY_SYNC_DELAY_MS = 3000;

// Timeout for single save endpoint (profile + all assignments in one request)
export const SAVE_STORE_CATEGORIES_TIMEOUT_MS = 90000;
